<script>
  import { Router, Route } from "svelte-routing";
  import Login from "./Components/Login.svelte";
  import NavBar from "./Components/NavBar.svelte";
  import Footer from "./Components/UI/Footer.svelte";
  import ConfirmDialog from "./Components/UI/ConfirmDialog.svelte";
  import Toaster from "./Components/UI/Toaster.svelte";
  import ErrorFiles from "./Components/Python_Files/ErrorFiles.svelte";
  import QueueFiles from "./Components/Python_Files/QueueFiles.svelte";
  import ReadyFiles from "./Components/Python_Files/ReadyFiles.svelte";
  import SolvedFiles from "./Components/Python_Files/SolvedFiles.svelte";

  // The login screen is its own full-height layout, so it gets no header, no
  // tab strip and no footer -- there is nothing to navigate to yet.
  $: isLogin = window.location.pathname === "/login";
</script>

<Router>
  <div class="flex min-h-screen flex-col bg-base-200 font-sans">
    {#if !isLogin}
      <NavBar />
    {/if}

    <main class="flex-grow">
      <div class="mx-auto w-full max-w-6xl px-4 pb-12 pt-6">
        <Route path="/">
          <ReadyFiles />
        </Route>

        <Route path="/error">
          <ErrorFiles />
        </Route>

        <Route path="/queue">
          <QueueFiles />
        </Route>

        <Route path="/solved">
          <SolvedFiles />
        </Route>

        <Route path="/login">
          <Login />
        </Route>
      </div>
    </main>

    {#if !isLogin}
      <Footer />
    {/if}
  </div>

  <!-- Mounted once, outside the routed area: a confirmation or a toast must
       outlive the component that triggered it (deleting a row unmounts the card
       that asked). -->
  <ConfirmDialog />
  <Toaster />
</Router>
